import { useGqlFullName } from "~/graphql/repo";
import { useRawCookie } from "~/composables/useRawCookie";
import { useHurstQuery } from "~/composables/useHurstQuery";

export const useFullName = () => {
  const gqlFullName = useGqlFullName();

  const env = useRuntimeConfig();
  const cookiesOptions = {
    path: "/",
    maxAge: 60 * 60 * 24 * 30,
    domain: env.public.hurstDomain,
  };

  const accountCookie = useCookie("account", cookiesOptions);
  const nidCookie = useRawCookie("nid", cookiesOptions);

  return useHurstQuery({
    queryKey: ["USER-FULL-NAME"],
    async queryFn() {
      const res = await gqlFullName();
      accountCookie.value = res.user?.id ?? null;
      nidCookie.value = res.user?.nid ?? null;
      return res.user.fullName;
    },
    staleTime: 60 * 60 * 1000,
  });
};
